<template>
<svg xmlns="http://www.w3.org/2000/svg" width="61.449" height="78.157" viewBox="0 0 61.449 78.157">
    <path id="Caminho_104" data-name="Caminho 104" d="M2186.074,2004.885l-7.951,3.328H2149.91l-18,22.342-.122-60.016,18.119-18.141,8.147,13.706,13.476,5.868,1.828,7.009,19.878,11.715Z" transform="translate(-2131.791 -1952.399)" fill="#fff"/>
</svg>
</template>